import React from 'react'
import { Link } from 'react-router-dom'
import { Item, Tag } from '@modules/admin/common/fields/suggestField/template'
import { sortArrayByKeyProp } from '@utilities/arrays'

export const createProfessionalGroupColumns = (t) => {
  // Ejemplo de columnas
  const columns = [
    { label: t('Nombre'), key: 'name' },
    { label: t('professionalsCount'), key: 'professionals_count' },
    { label: t('assignedUserGroups'), key: 'company_groups' },
    { label: t('actions'), key: 'actions', className: 'small right-align' },
  ]
  return columns
}
export const createUserGroupColumns = (t) => {
  // Ejemplo de columnas
  const columns = [
    { label: t('Nombre'), key: 'name' },
    { label: t('Compañía'), key: 'company' },
    { label: t('usersCount'), key: 'customers_count' },
    { label: t('assignedSpecialities'), key: 'specialities' },
    { label: t('assignedProfessionalGroups'), key: 'teams' },
    { label: t('actions'), key: 'actions', className: 'small right-align' },
  ]
  return columns
}
export const createProfessionalGroupRows = ({ columns, rows, kind, onDelete }) => {
  const headerKeys = columns.map((el) => el.key)
  return rows.map((item, key) => {
    return (
      <tr key={key}>
        {headerKeys.map((key, index) => {
          let component
          let className
          if (key === 'name') component = item[key]
          if (key === 'professionals_count') component = item[key]
          if (key === 'company_groups') component = item[key].map((el) => `${el.name} (${el?.company.name})`).join(', ')
          if (key === 'actions') {
            className = 'right-align'
            component = (
              <>
                <Link to={`/groups/${kind}/update/${item.id}`} className="fas fa-pen" />
                <i className="fas fa-trash" onClick={() => onDelete(item)} />
              </>
            )
          }
          return <td className={className}>{component}</td>
        })}
      </tr>
    )
  })
}
export const createCustomerGroupRows = ({ columns, rows, kind, onDelete, currentLanguage }) => {
  const headerKeys = columns.map((el) => el.key)
  return rows.map((item, key) => {
    return (
      <tr key={key}>
        {headerKeys.map((key, index) => {
          let component
          let className

          if (key === 'name' || key === 'customers_count') component = item[key]
          if (key === 'company') component = item[key].name
          if (key === 'teams')
            component = sortArrayByKeyProp(item[key], 'priority')
              .map((item) => item.name)
              .join(', ')
          if (key === 'specialities')
            component = item[key]
              .map(({ translations }) => translations.find((tr) => tr.locale === currentLanguage).name)
              .join(', ')
          if (key === 'actions') {
            className = 'right-align'
            component = (
              <>
                <Link to={`/groups/${kind}/update/${item.id}`} className="fas fa-pen" />
                {!item.is_default && <i className="fas fa-trash" onClick={() => onDelete(item)} />}
              </>
            )
          }
          return <td className={className}>{component}</td>
        })}
      </tr>
    )
  })
}

export const createTags = ({ name, tags, deleteItem }) => {
  if (!tags) return null
  return tags.map((item, key) => {
    let result
    if (name === 'professionals' || name === 'teams_ids')
      result = <Tag text={item.name} deleteItem={() => deleteItem(item)} key={key} />
    if (name === 'company_groups')
      result = <Tag text={`${item.name} - ${item.company.name}`} deleteItem={() => deleteItem(item)} key={key} />
    if (name === 'customers')
      result = (
        <Tag text={`${item.firstname} - ${item.company_group_name}`} deleteItem={() => deleteItem(item)} key={key} />
      )
    if (name === 'userGroups') result = <Tag text={item.name} deleteItem={() => deleteItem(item)} key={key} />
    if (name === 'teams') {
      result = <Tag text={item.name} deleteItem={() => deleteItem(item)} key={key} dataId={item.id} />
    }
    return result
  })
}

export const createList = ({ data, name, selectItem, chosenList, setDisplay, value }) => {
  if (!data) return null
  return data.map((item, key) => {
    let used = !!value ? value.map((item) => item.id || item.hash).includes(item.id || item.hash) : false

    let result

    if (['teams', 'teams_ids'].includes(name)) {
      result = (
        <Item
          selectItem={() => {
            !used ? selectItem(item) : setDisplay(false)
          }}
          text={item.name}
          key={key}
          used={used}
        />
      )
    }
    if (['customers'].includes(name)) {
      result = (
        <Item
          selectItem={() => {
            !used ? selectItem(item) : setDisplay(false)
          }}
          text={`${item.firstname} - ${item.company_group_name}`}
          key={key}
          used={used}
        />
      )
    }
    if (['company_groups'].includes(name)) {
      result = (
        <Item
          selectItem={() => {
            !used ? selectItem(item) : setDisplay(false)
          }}
          text={`${item.name} - ${item.company.name}`}
          key={key}
          used={used}
        />
      )
    }
    if (['professionals'].includes(name)) {
      result = (
        <Item
          selectItem={() => {
            !used ? selectItem(item) : setDisplay(false)
          }}
          text={`${item.name} - ${item.nid_number || 'unknown'}`}
          key={key}
          used={used}
        />
      )
    }

    return result
  })
}

export const createAsociatedCustomersColumns = ({ isDefaultGroup, t }) => {
  // Ejemplo de columnas
  const columns = [
    { label: t('Nombre'), key: 'firstname' },
    { label: t('Token'), key: 'token' },
    { label: '', key: 'actions', hide: isDefaultGroup },
  ]
  return columns.filter((it) => !it.hide)
}

export const createAsociatedCustomersRows = ({ columns, rows, onDelete }) => {
  const headerKeys = columns.map((el) => el.key)

  return rows.map((item, key) => {
    return (
      <tr key={key}>
        {headerKeys.map((key, index) => {
          let component
          let className
          if (key === 'firstname') component = item[key]
          if (key === 'token') component = item[key]
          if (key === 'actions') {
            className = 'right-align'
            component = (
              <div className="table-icons">
                <i className="fas fa-trash" onClick={() => onDelete(item)} />
              </div>
            )
          }
          return <td className={className}>{component}</td>
        })}
      </tr>
    )
  })
}
export const createSpecialityColumns = () => {
  // Ejemplo de columnas
  const columns = [
    { label: 'name', key: 'name' },
    { label: 'schedules', key: 'schedules' },
    { label: '', key: 'actions' },
  ]
  return columns
}
export const createSpecialityRows = ({ columns, rows, onSelect, onRemove }) => {
  const headerKeys = columns.map((el) => el.key)
  return rows.map((item, key) => {
    return (
      <tr key={key}>
        {headerKeys.map((key, index) => {
          let component
          if (key === 'name') component = item[key]
          if (key === 'schedules') {
            if (!item[key]) {
              return <td>{'No Data'}</td>
            }
            var nuevo = {}
            var newList = {}
            item[key].forEach((item) => {
              let { start1, finish1, day } = item
              if (start1 && finish1) newList[day] = `${start1} - ${finish1}`
            })
            for (var elem in newList) {
              if (newList[elem]) {
                nuevo[newList[elem]] = nuevo[newList[elem]] ? nuevo[newList[elem]] : []
                nuevo[newList[elem]].push(elem)
              }
            }
            let formatList = []
            for (const elem in nuevo) {
              var days = nuevo[elem].map((day) => {
                let result = 'L'
                switch (day) {
                  case 'lunes':
                    result = 'L'
                    break
                  case 'martes':
                    result = 'M'
                    break
                  case 'miercoles':
                    result = 'X'
                    break
                  case 'jueves':
                    result = 'J'
                    break
                  case 'viernes':
                    result = 'V'
                    break
                  case 'sabado':
                    result = 'S'
                    break
                  case 'domingo':
                    result = 'D'
                    break
                  default:
                }
                return result
              })
              let format = `${days.join(',').replaceAll(',', ' ')} - ${elem}`
              formatList.push(format)
            }
            component = formatList.map((item) => {
              return <div className="prueba">{item ? item : 'No hay horarios aún'}</div>
            })
          }
          if (key === 'actions')
            component = (
              <div className="table-icons">
                <i className="fas fa-pen" onClick={() => onSelect(item)} />
                <i className="fas fa-trash" onClick={() => onRemove(item)} />
              </div>
            )
          return <td>{component}</td>
        })}
      </tr>
    )
  })
}
